import dayjs from 'dayjs';
import { RESULT_BIG, RESULT_SAME, RESULT_SMALL } from '@/types';

import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export const now = (aData: string = '', aFormat: string = 'YYYY-MM-DD HH:mm:ss') => {
  return aData ? dayjs(aData).format(aFormat) : dayjs().format(aFormat);
};

export const addTime = (aData: string = '', aAdd: number = 9) => {
  const currentDate = aData ? dayjs(aData) : dayjs();
  // 9시간을 더하기 (한국 시간으로 변경)
  const newDate = currentDate.add(aAdd, 'hour');
};

export const compareDate = (aDay1: string, aDay2: string): number => {
  const d1 = dayjs(aDay1);
  const d2 = dayjs(aDay2);
  if (d1.isAfter(d2)) {
    // console.log('date1은 date2보다 이후입니다.');
    return RESULT_BIG;
  } else if (d1.isBefore(d2)) {
    // console.log('date1은 date2보다 이전입니다.');
    return RESULT_SMALL;
  } else {
    // console.log('date1과 date2는 같은 날짜입니다.');
    return RESULT_SAME;
  }
};

// 한국 시간으로 변환
export const utcToAddTime = (aData: string, aAdd: number = 9) => {
  return dayjs.utc(aData).add(aAdd, 'hour').format('YYYY-MM-DD HH:mm:ss');
};
